import uniqBy from 'lodash/uniqBy';

function convertDataStructureToCommon(data, transportType) {
    const transportTypes = {
        Bus: 'BLT',
        Metro: 'ULT',
        Train: 'SLT'
        //https://www.trafiklab.se/api/trafiklab-apis/resrobot-v21/common/
    };

    const dataByTransportType = data.filter(transport => transport.ProductAtStop.catOutS === transportTypes[transportType])
    const trains = dataByTransportType.reduce((acc, el) => {
        const routes = data.filter(route => route?.ProductAtStop?.num === el?.ProductAtStop?.num);
        const times = routes.map(i => i.time.split(':', 2).join(':'));

        acc.push({
            name: el.name,
            destination: el.direction,
            route: el?.ProductAtStop?.num,
            routeId: el?.ProductAtStop?.num,
            convertedTimeSlots: true,
            times
        });

        return acc;

    }, []);

    return [{ number: ''/*data[0].JourneyStatus*/, trains: uniqBy(trains, 'route') }]
}

export {
    convertDataStructureToCommon
}
